@if (isDisplayed$() | async) {
  @if (description) {
    <p>{{ description | loadTemplateData$ | async }}</p>
  }
  @if (isButton()) {
    <button (click)="triggerAction()" data-e2e="button-block-trigger-action" mat-raised-button [ngClass]="{inverted: isSecondary()}">
      @if (icon) {
        <mat-icon [svgIcon]="icon"></mat-icon>
      }
      <span>{{ text | loadTemplateData$ | async | translate }}</span>
    </button>
  }
  @if (!isButton()) {
    <a data-e2e="button-block-trigger-link-action" (click)="triggerAction()">
      {{ text | loadTemplateData$ | async | translate }}
    </a>
  }
}
